<div class="webgl-unsupported-container" data-testid="webgl-unsupported" khA11yAlert>
  <kh-img class="warning-icon" path="https://staticcontent.knowledgehook.com/content/khg/ui/common/warning.png" [alt]="'WEBGL_UNSUPPORTED.WARNING_ICON_ALT' | translate"></kh-img>
  <p class="warning-message white">{{ 'WEBGL_UNSUPPORTED.MESSAGE' | translate }}</p>
</div>
